import emojiRanges from "./personalNameEmojiRanges.json";

const controlCharacterPattern = /[\p{Cc}\p{Cf}\p{Cs}\p{Zl}\p{Zp}]/u;

export function isPersonalNameValid(name: string): boolean {
  if (name.length > 100 || name.trim().length === 0) {
    return false;
  }

  for (const character of name) {
    // Preserve the joiners used in Indic and Persian names.
    if (character === "\u200c" || character === "\u200d") {
      continue;
    }

    const codePoint = character.codePointAt(0)!;
    if (controlCharacterPattern.test(character) || codePoint === 0x20e3 ||
        emojiRanges.some(([start, end]) => codePoint >= start && codePoint <= end)) {
      return false;
    }
  }

  return true;
}
